import PropTypes from 'prop-types';

const ReportingProps = {};

ReportingProps.i18n = PropTypes.shape({
  formatDate: PropTypes.func.isRequired,
  formatPercent: PropTypes.func.isRequired,
  getCurrencySymbol: PropTypes.func.isRequired,
  getString: PropTypes.func.isRequired,
  isReady: PropTypes.func.isRequired,
  parseDate: PropTypes.func.isRequired,
  parseDecimal: PropTypes.func.isRequired,
});

ReportingProps.instrumentationSchema = PropTypes.shape({
  scenario: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    activity: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })).isRequired,
  })).isRequired,
});

ReportingProps.reactRouterLocation = PropTypes.shape({
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string,
  hash: PropTypes.string,
});

ReportingProps.reactRouterMatch = PropTypes.shape({
  params: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])).isRequired,
  path: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isExact: PropTypes.bool.isRequired,
});

ReportingProps.reactRouterHistory = PropTypes.shape({
  go: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
});

ReportingProps.instrumentation = PropTypes.object;

ReportingProps.reportList = PropTypes.shape({
  reportsTree: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    children: PropTypes.array,
  }).isRequired,
  reports: PropTypes.object.isRequired,
  isValidCreateReportId: PropTypes.func.isRequired,
  isValidCategoryId: PropTypes.func.isRequired,
});

ReportingProps.reportDescription = PropTypes.oneOfType([
  PropTypes.string.isRequired,
  PropTypes.shape({
    what: PropTypes.string.isRequired,
    why: PropTypes.string.isRequired,
  }).isRequired,
]);

ReportingProps.reportDefinition = PropTypes.shape({
  apiKey: PropTypes.string.isRequired,
  description: ReportingProps.reportDescription.isRequired,
  name: PropTypes.string.isRequired,
});

ReportingProps.logger = PropTypes.shape({
  mark: PropTypes.func.isRequired,
  trace: PropTypes.func.isRequired,
  error: PropTypes.func.isRequired,
});

ReportingProps.identityDetails = PropTypes.shape({
  user: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    ParentCustomerId: PropTypes.number.isRequired,
  }).isRequired,
  customer: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  lcid: PropTypes.number.isRequired,
});

ReportingProps.updateId = PropTypes.string;
ReportingProps.permissions =
  PropTypes.shape({});

ReportingProps.reportSchema = PropTypes.object;

ReportingProps.repository = PropTypes.shape({
  getDetailsByExecutionId: PropTypes.func.isRequired,
});

ReportingProps.servicesEndpoints = PropTypes.shape({
  CampaignAPI: PropTypes.string.isRequired,
  ClientCenterUIAPI: PropTypes.string.isRequired,
  Token: PropTypes.string.isRequired,
});

export { ReportingProps as default };
